import { DestroyRef, inject } from '@angular/core';
import { ReplaySubject } from 'rxjs';

export class BaseSpinnerOverlayComponent {
  readonly forceCloseLoading$ = new ReplaySubject<void>(1);
  readonly destroyRef = inject(DestroyRef);
}
